import {differenceInMilliseconds, parseISO} from 'date-fns'
import * as React from 'react'

import useTimeSelector from '../../../../../../hooks/useTimeSelector'
import {formatDuration, MS_IN_SEC} from '../../../../../../utils/dateTimeUtils'

type Props = {
  duration: number | null | undefined
  className?: string
  timestamp?: string
}

function LogMessageDuration({duration, className, timestamp}: Props) {
  const effectiveDuration = useTimeSelector(
    now =>
      duration ?? (timestamp != null ? differenceInMilliseconds(now, parseISO(timestamp)) : null),
  )
  if (effectiveDuration != null) {
    return (
      <span className={className} data-test-log-message-duration>{`\u00a0${
        duration != null ? '' : 'running\u00a0for\u00a0'
      }${formatDuration(Math.round(effectiveDuration / MS_IN_SEC))}`}</span>
    )
  }

  return null
}

export default React.memo<Props>(LogMessageDuration)
